module.exports = __webpack_public_path__ + "static/img04-7058525eecd5431ab34510f80364271f.jpg";